import React, { useState } from "react";
import styles from './CreatePasswordForm.module.scss';
import PropTypes from "prop-types";
import Logo from "../logo/Logo";
import PasswordField from "../passwordField/PasswordField";
import TextField from "../textField/TextField";
import Alert from "../alert/Alert";
import Checkbox from "../checkbox/Checkbox";
import Button from "../button/Button";

const CreatePasswordForm = ({
  onSubmit,
  error
}) => {
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');
  const [newPasswordHasError, setNewPasswordHasError] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  
  const validateNewPassword = () => {
    if(!newPassword) {
      return 'New Password is required';
    }
    return '';
  }
  
  const validateConfirmPassword = () => {
    if(!confirmPassword) {
      return 'Confirm Password is required';
    }
    if(confirmPassword !== newPassword) {
      return 'New Password and Confirm Password does not match';
    }
    return '';
  }

  const handleCreatePassword = () => {
    const newPasswordValidationResult = validateNewPassword();
    const confirmPasswordValidationResult = validateConfirmPassword();

    setNewPasswordError(newPasswordValidationResult);
    setConfirmPasswordError(confirmPasswordValidationResult);

    if (newPasswordValidationResult || confirmPasswordValidationResult) {
      return false;
    }

    if(newPasswordHasError) {
      return false;
    }

    onSubmit(newPassword);
  };

  return (
    <div className={styles.container}>
      <Logo />
      <h1 className={styles.title}>Create a strong password</h1>
      { error && <Alert message={error} type="error" /> }
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          handleCreatePassword();
        }}
      >
        <PasswordField
          label="New Password"
          onChange={(value, hasError) => {
            setNewPasswordError('');
            setNewPassword(value);
            setNewPasswordHasError(hasError);
            if(confirmPassword && value !== confirmPassword) {
              setConfirmPasswordError('New Password and Confirm Password does not match');
            } else {
              setConfirmPasswordError('');
            }
          }}
          showPassword={showPassword}
          error={newPasswordError}
        />
        <TextField 
          label="Confirm Password"
          type={showPassword ? 'text' : 'password'}
          value={confirmPassword}
          onChange={(value) => {
            setConfirmPassword(value);
            if(value && value !== newPassword) {
              setConfirmPasswordError('New Password and Confirm Password does not match');
            } else {
              setConfirmPasswordError('');
            }
          }}
          error={confirmPasswordError}
        />
        <Checkbox
          label="Show Password"
          checked={showPassword}
          onChange={(value) => setShowPassword(value)}
        />
        <div className={styles.submit}>
          <Button
            label="Create Password"
            type="submit"
          />
        </div>
      </form>
    </div>
  );
};

CreatePasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
}

export default CreatePasswordForm;